import React, { Component } from 'react';
import { Checkbox } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { Search as SearchInput } from 'components/my-events/search';
import { FormattedMessage } from 'react-intl';
import Search from '../../../../assets/input_search.svg';
import EventsIcon from '../../../../assets/events.svg'
import SearchIcon from '../../../../assets/search.svg';
import OpenInNewIcon from '../../../../assets/open-in-new.svg';
import styles from '../styles-module.css';
import { messages } from '../locale';
import LoadingSpinner from '../../../loading';
import ListingRow from './listing-row';
import { SELECTED_LISTINGS_APPLIED } from '../../consts';

export class ListingTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTicketTypes: {},
    };
  }

  componentDidUpdate(previousProps) {
    const { setSearchText, setSelectedFilterIndex } = this.props;
    if (previousProps.selectedCurrency !== this.props.selectedCurrency) {
      setSearchText(null);
      setSelectedFilterIndex(0);
    }
  }

  setShowTicketTypes = (listingId, showTicketTypes) => {
    const currentShowTicketTypes = { ...this.state.showTicketTypes };
    currentShowTicketTypes[listingId] = showTicketTypes;
    this.setState({ showTicketTypes: currentShowTicketTypes });
  }

  drawTable() {
    const {
      listings,
      intl,
      updateListingIds,
      listingIds,
      hideCheckBoxes,
      isEditOrCreateMode,
      selectedTicketTypes,
      setSelectedTicketTypes,
    } = this.props;

    return listings.map((listing) => {
      const renderListingRow = <ListingRow
        listing={listing}
        listingIds={listingIds}
        updateListingIds={(ids) => updateListingIds(ids)}
        key={`${listing.id} ${listingIds}`}
        intl={intl}
        hideCheckBoxes={hideCheckBoxes}
        setShowTicketTypes={this.setShowTicketTypes}
        showTicketTypes={this.state.showTicketTypes[listing.id]}
        selectedTicketTypes={selectedTicketTypes}
        setSelectedTicketTypes={setSelectedTicketTypes}
      />;

      if (!isEditOrCreateMode) {
        if (listingIds.includes(listing.id)) 
          return renderListingRow;
        return <></>;
      }
      return renderListingRow;
    });
  }

  selectFilter = (index, filter) => {
    const { fetchListings, setSelectedFilterIndex, searchText } = this.props;
    setSelectedFilterIndex(index);
    fetchListings({
      variables: {
        addOnId: '',
        eventStates: filter ? [filter] : null,
        search: searchText,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return { ...prev, ...fetchMoreResult };
      }
    });
  }

  removeAllFilters = () => {
    const { fetchListings, setSelectedFilterIndex, setSearchText } = this.props;
    setSelectedFilterIndex(0);
    setSearchText(null);

    fetchListings({
      variables: {
        addOnId: '',
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return { ...prev, ...fetchMoreResult };
      }
    });
  }

  handleSearch = (searchText) => {
    const { fetchListings, selectedFilterIndex, setSearchText, listingSelectorFilters } = this.props;
    const selectedEventState = listingSelectorFilters[selectedFilterIndex].value;
    setSearchText(searchText);

    fetchListings({
      variables: {
        addOnId: '',
        search: searchText,
        eventStates: selectedEventState ? [selectedEventState] : null,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return { ...prev, ...fetchMoreResult };
      },
    });
  }

  selectAllTicketTypesOfAllEvents = () => {
    const { listings, setSelectedTicketTypes } = this.props;
    const selectedTicketTypes = {};
    listings.forEach(listing => {
      const ticketTypeIds = listing?.rates?.nodes.map(ticketType => ticketType.id);
      selectedTicketTypes[listing?.id] = new Set(ticketTypeIds);
    })
    setSelectedTicketTypes(selectedTicketTypes);
  }

  handleAllEventSelection = (isChecked) => {
    const { listings, listingIds, updateListingIds, setSelectedTicketTypes } = this.props;
    if (!isChecked) {
      updateListingIds([]);
      setSelectedTicketTypes({});
    }
    else if (listingIds.length === 0 ) {
      const allListingIds = listings.map(listing => listing.id);
      updateListingIds(allListingIds);
      this.selectAllTicketTypesOfAllEvents();
    }
  }

  isEditAddOns = () => {
    const { isEditPage, listingsMode } = this.props;  
    return isEditPage && [SELECTED_LISTINGS_APPLIED].includes(listingsMode);
  }

  renderNoEventsFound = () => {
    const { intl: { formatMessage }, selectedCurrency, selectedFilterIndex, searchText } = this.props;
    const filtersApplied = selectedFilterIndex || searchText;
    
    if (filtersApplied) {
      return (
        <div className={styles.noEventsContainer}>
          <div><SearchIcon /></div>
          <div>{formatMessage(messages.noEventsFoundOnFilters)}</div>
          <div className={styles.creatEventButton} onClick={_ => this.removeAllFilters()} role="button" tabIndex={0}>
            {this.props.intl.formatMessage(messages.removeAllFilters)}
          </div>
        </div>
      );
    }
    
    return (
      <div className={styles.noEventsContainer}>
        <div><EventsIcon /></div>
        <div>
          <FormattedMessage
            { ...messages.noEventsFound }
            values={{ currencyCode: selectedCurrency }}
          />
        </div>
        <Link to="/create" target="_blank" rel="noopener noreferrer" className={styles.creatEventButton}>  
          {formatMessage(messages.createEvent)} <OpenInNewIcon />
        </Link>
      </div> 
    );        
  }

  renderTableFilter = () => {
    return <div className={styles.listingTableFilters}>
      {this.props.listingSelectorFilters.map((filter, index) => {
        const { selectedFilterIndex } = this.props;
        const filterClasses = selectedFilterIndex === index ? styles.selected : '';
        const filterDivideClasses = () => {
          const filterDivideSelectedClasses = `${styles.filterDivide} ${styles.filterDivideSelected}`;
          if (index === 0 && (selectedFilterIndex === 0 || selectedFilterIndex === 1)) {
            return filterDivideSelectedClasses;
          }
          else if (index === 1 && (selectedFilterIndex === 1 || selectedFilterIndex === 2)) {
            return filterDivideSelectedClasses;
          }
          return styles.filterDivide;
        }

        return <>
          <div
            className={filterClasses} 
            onClick={() => this.selectFilter(index, filter.value)}
            role="button"
            tabIndex={index}
          >
            {filter.text}
          </div>
          {index !== 2 && <span className={filterDivideClasses()} />}
        </>
      })} 
    </div>
  }

  renderSearch = () => {
    const { intl, searchText } = this.props;
    return <div className={styles.listingTableSearch}>
      <SearchInput
        onUpdateSearchText={(value) => this.handleSearch(value?.length ? value : null)}
        placeholder={intl.formatMessage(messages.searchPlaceholder)}
        intl={intl}
        customIcon={<Search className={styles.searchIcon} color="black" />}
        showLoadingState
        searchTextValue={searchText}
      />
    </div>
  }

  renderTableHeaderTitle = () => {
    const { listingIds, intl } = this.props;
    if (this.isEditAddOns() || listingIds?.length === 0) {
      return intl.formatMessage(messages.title);
    }

    const headerText = listingIds.length === 1 ? messages.selectedEventCounter : messages.selectedEventsCounter;
    return <FormattedMessage
      { ...headerText }
      values={{ listingIdsCount: listingIds.length }}
    />;
  }

  render() {
    const { loading, intl, hasEvents, listingIds, listings, hideCheckBoxes } = this.props;
    const selectedListingIdsCount = listingIds?.length;
    const listingHeaderClasses = `${styles.column} ${styles.title}
      ${selectedListingIdsCount < listings?.length ? styles.eventSelected : ''}`;
    const checkBoxClasses = `${hideCheckBoxes ? styles.hiddenCheckBox : ''}`;

    let content;
    let tableHeader;

    if (loading) {
      content = (
        <div className={styles.row}>
          <LoadingSpinner className={styles.loadingSpinner} />
        </div>
      );
    }
    else {
      const tableHeaderClasses =
        `${styles.listingsTableHeader} ${selectedListingIdsCount === 0 ? styles.ListingsTableHeaderWithoutEvents : ''}`;
      const showTableHeaders = selectedListingIdsCount === 0 || this.props.showEditButton;

      tableHeader = (
        <div className={tableHeaderClasses}>
          <div 
            className={listingHeaderClasses}
          >
            <Checkbox
              className={checkBoxClasses}
              checked={selectedListingIdsCount}
              onChange={(_, { checked }) => {this.handleAllEventSelection(checked)}}
            />
            <div>{this.renderTableHeaderTitle()}</div>
          </div>
          <div className={`${styles.column} ${styles.status}`}>
            {showTableHeaders ? intl.formatMessage(messages.status) : ''}
          </div>
          <div className={`${styles.column} ${styles.date}`}>
            {showTableHeaders ? intl.formatMessage(messages.date) : ''}
          </div>
          <div className={`${styles.column} ${styles.actions}`} />
        </div>
      );
      content = this.drawTable();
    }

    return (
      <div className={`${styles.desktopAddOnsTable}`}>
        <div className={`${styles.filterTopLine} ${this.isEditAddOns() ? styles.hidden : ''}`} />
        <div className={`${styles.filterContainer} ${this.isEditAddOns() ? styles.hidden : ''}`}>
          {this.renderTableFilter()}
          {this.renderSearch()}
        </div>
        <div className={styles.headerTopLine} />
        {(hasEvents || loading) ? tableHeader : this.renderNoEventsFound()}
        <div className={styles.line} />
        <div className={styles.listingTableContent}>
          {content}
        </div>
      </div>
    );
  }
}

export default ListingTable;
